import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';

import { AppShellService } from './services/app-shell.service';

const SIDENAV_TRANSITION_PROPERTY = 'grid-template-columns';

@Component({
  selector: 'mop-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppShellComponent {
  private readonly appShellService = inject(AppShellService);
  sideNavOpen = this.appShellService.sideNavOpen;
  sideNavTransition = this.appShellService.sideNavTransition;

  protected computedClasses = computed(() => ({
    'sidenav-open': this.sideNavOpen(),
  }));

  onTransitionStart() {
    this.sideNavTransition.set('start');
  }

  onTransitionEnd(event: TransitionEvent) {
    if (event.propertyName === SIDENAV_TRANSITION_PROPERTY) {
      this.sideNavTransition.set('end');
    }
  }
}
